import { __decorate } from "tslib";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AllMessages from '@/components/v3/inbox_manager/AllMessages.vue';
import MessengerMessages from '@/components/v3/inbox_manager/MessengerMessages.vue';
import FacebookComments from '@/components/v3/inbox_manager/FacebookComments.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import SendMessengerReply from '@/plugins/graphql/mutations/copilot_inbox_manager/send-messenger-reply.gql';
import SendFbCommentReply from '@/plugins/graphql/mutations/copilot_inbox_manager/send-fb-comment-reply.gql';
let Messages = class Messages extends Mixins(PaginatorMixin, AlertMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.messageIcon = require('@/assets/icons/message.svg');
        this.facebookIcon = require('@/assets/icons/facebook.svg');
        this.messengerIcon = require('@/assets/images/messenger-logo.svg');
        this.emptyStateIcon = require('@/assets/icons/inbox-message.svg');
        this.selectedFilter = 'facebook';
        this.typedMessage = '';
        this.commentId = '';
        this.hasMultiplePlaformOrigin = true;
    }
    onRecipientChanged() {
        if (this.selectedRecipient.inboxPlatformOrigin) {
            if (this.selectedRecipient.inboxPlatformOrigin &&
                this.selectedRecipient.inboxPlatformOrigin.length > 1 &&
                this.selectedInboxFilter === 'all') {
                this.hasMultiplePlaformOrigin = true;
                this.selectedFilter = 'comments';
                return;
            }
            this.selectedRecipient.inboxPlatformOrigin.forEach((platform) => {
                if (platform === 'messenger' && this.selectedInboxFilter === 'messenger') {
                    this.selectedFilter = 'messenger';
                }
                if (platform === 'facebook_comment' && this.selectedInboxFilter === 'facebook_comment') {
                    this.selectedFilter = 'comments';
                }
                if (platform === 'messenger' && this.selectedInboxFilter === 'all') {
                    this.selectedFilter = 'messenger';
                }
                if (platform === 'facebook_comment' && this.selectedInboxFilter === 'all') {
                    this.selectedFilter = 'comments';
                }
                this.hasMultiplePlaformOrigin = false;
            });
        }
    }
    onRecipientsChanged() {
        if (this.selectedRecipient.inboxPlatformOrigin &&
            this.selectedRecipient.inboxPlatformOrigin.length > 1 &&
            this.selectedInboxFilter === 'all') {
            this.hasMultiplePlaformOrigin = true;
        }
    }
    onFbpostChanged() {
        if (this.selectedFbpost.isReplyingValue) {
            this.$refs.messageTextarea.focus();
            this.commentId = this.selectedFbpost.commentId;
        }
        else {
            if (this.$refs.messageTextarea) {
                this.$refs.messageTextarea.blur();
            }
            this.commentId = '';
        }
    }
    onInboxFilterChanged() {
        if (this.selectedInboxFilter === 'messenger') {
            this.hasMultiplePlaformOrigin = false;
            this.selectedFilter = 'messenger';
        }
        if (this.selectedInboxFilter === 'facebook_comment') {
            this.hasMultiplePlaformOrigin = false;
            this.selectedFilter = 'comments';
        }
        if (this.selectedInboxFilter === 'all') {
            this.selectedFilter = 'all-message';
        }
    }
    onFilterChanged() {
        this.$store.commit('setSelectedFbpost', {});
    }
    async sendMessengerReply() {
        return this.$apollo
            .mutate({
            mutation: SendMessengerReply,
            variables: {
                input: {
                    pageRecipientUuid: this.$store.state.selectedRecipient.uuid,
                    message: this.typedMessage.trim(),
                },
            },
        })
            .catch((e) => {
            const vm = this;
            vm.$refs.messenger.deleteString();
            this.errorNotification(e.message);
        });
    }
    async sendFbCommentReply(comment_id) {
        return this.$apollo
            .mutate({
            mutation: SendFbCommentReply,
            variables: {
                input: {
                    pageRecipientUuid: this.$store.state.selectedRecipient.uuid,
                    message: this.typedMessage.trim(),
                    commentId: comment_id,
                },
            },
        })
            .catch((e) => {
            const vm = this;
            if (vm.$refs.facebook && vm.$refs.facebook.$refs.inboxConvo) {
                const component = vm.$refs.facebook.$refs.inboxConvo;
                component[0].deleteComment();
            }
            this.errorNotification(e.message);
        });
    }
    passMessage(string) {
        const vm = this;
        if (this.selectedFbpost && this.selectedFbpost.commentId) {
            if (vm.$refs.facebook && vm.$refs.facebook.$refs.inboxConvo) {
                const component = vm.$refs.facebook.$refs.inboxConvo;
                component[0].receiveComment(string, this.selectedFbpost.commentId);
            }
        }
        else {
            vm.$refs.messenger.receiveString(string);
        }
    }
    async sendMessage() {
        const mutation = () => {
            if (this.selectedFbpost && this.selectedFbpost.commentId) {
                return this.sendFbCommentReply(this.selectedFbpost.commentId);
            }
            return this.sendMessengerReply();
        };
        this.$nextTick(() => {
            this.passMessage(this.typedMessage.trim());
            this.clearMsg();
        });
        await mutation()
            .then(() => {
            this.successNotification('Message sent successfully');
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
    clearMsg() {
        this.typedMessage = '';
    }
    clearTypedMessage() {
        this.typedMessage = '';
    }
    get disableSendButton() {
        const trimmedMessage = this.typedMessage.trim();
        if (this.selectedFilter === 'comments') {
            return this.commentId === '' || trimmedMessage === '';
        }
        return trimmedMessage === '';
    }
    resize() {
        const element = this.$refs.messageTextarea;
        element.style.height = '18px';
        element.style.height = `${element.scrollHeight}px`;
    }
    mounted() {
        this.onRecipientChanged();
    }
};
__decorate([
    Getter('selectedRecipient')
], Messages.prototype, "selectedRecipient", void 0);
__decorate([
    Getter('selectedFbpost')
], Messages.prototype, "selectedFbpost", void 0);
__decorate([
    Getter('selectedFilter')
], Messages.prototype, "selectedInboxFilter", void 0);
__decorate([
    Getter('recipients')
], Messages.prototype, "recipients", void 0);
__decorate([
    Watch('selectedRecipient')
], Messages.prototype, "onRecipientChanged", null);
__decorate([
    Watch('recipients')
], Messages.prototype, "onRecipientsChanged", null);
__decorate([
    Watch('selectedFbpost')
], Messages.prototype, "onFbpostChanged", null);
__decorate([
    Watch('selectedInboxFilter')
], Messages.prototype, "onInboxFilterChanged", null);
__decorate([
    Watch('selectedFilter')
], Messages.prototype, "onFilterChanged", null);
Messages = __decorate([
    Component({
        components: {
            MessengerMessages,
            FacebookComments,
            AllMessages,
        },
        methods: {},
        computed: {
        // selectedFbPost() {
        //   return this.$store.state.selectedFbpost;
        // },
        // disableSendButton(): boolean {
        //   if (this.selectedFilter === 'comments') {
        //     return !this.selectedFbPost?.commentId || this.typedMessage === '';
        //   }
        //   return this.typedMessage === '';
        // },
        },
    })
], Messages);
export default Messages;
